module.exports = __webpack_public_path__ + "static/media/om.da7eb358.svg";